// extracted by mini-css-extract-plugin
module.exports = {"price":"bR","onSale":"cR"};